export const ORDER_SUMMARY = "order summary"
export const CALL_SUPPORT_PHONE_NUMBER = "call support phone number"
export const HELP_SUPPORT = "help support"